export default "__VITE_ASSET__qmKwZQa7__"